import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';
import Button, {ModalXButton} from 'components/Button';
import Footer from 'components/Footer';
import Spinner from 'components/Spinner';

import handleInputChange from 'utils/handleInputChange';

import './style.css';

/* eslint-disable max-len */
export class SendAnnouncement extends React.Component {
  constructor() {
    super();

    this.state = {
      message: '',
    };

    // handlers
    this.handleInputChange = handleInputChange.bind(this);
    this.handlePageSubmit = this.handlePageSubmit.bind(this);
  }
  handlePageSubmit() {
    const {message} = this.state;

    // dispatch submit
    if (this.canSubmit()) {
      this.props.submit({
        message,
      });
    }
  }
  canSubmit() {
    return !!this.state.message;
  }
  render() {
    if (this.props.sending) {
      return (
        <Page>
          <Spinner />
        </Page>
      );
    } else {
      return (
        <Page>
          <header styleName="header toplevel">
            <h2 styleName="h2">Send Announcement</h2>
            <ModalXButton onClick={() => { this.props.cancel(); }} data-test="announcement_cancel" />
          </header>
          <p styleName="toplevel">
            Email your investors regularly to keep them updated on the progress of this deal.
          </p>
          <form styleName="toplevel form">
            <textarea id="message" name="message" rows="8" style={{width: '100%'}} onChange={this.handleInputChange} data-test="announcement_message" placeholder="Enter your message here" />
          </form>
          <Footer styleName="toplevel">
            <Button onClick={this.handlePageSubmit} disabled={!this.canSubmit()} data-test="announcement_submit">
              Send
            </Button>
          </Footer>
        </Page>
      );
    }
  }
}
/* eslint-enable max-len */

SendAnnouncement.propTypes = {
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};

export default SendAnnouncement;



// WEBPACK FOOTER //
// ./web/flows/deal/announce/component.js